var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nightsky"},[_c('div',{staticClass:"stars"}),_c('div',{staticClass:"twinkling"}),(_vm.showClouds)?_c('div',{staticClass:"clouds"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }